"use client";

import { lazy, useState } from "react";

import { useCommandMenu } from "@/components/command-menu/useCommandMenu";
import DebugPanelIcon from "@/components/debug-panel/DebugPanel.svg";

const DebugPanelWithDnD = lazy(async () => {
  const mod = await import(
    /* webpackChunkName: "DebugPanelWithDnD" */ "@/components/debug-panel/DebugPanel"
  );
  return { default: mod.DebugPanelWithDnD };
});

export function DebugPanelLoader() {
  const [opened, setOpened] = useState(false);

  useCommandMenu(
    () => ({
      id: "dev-tools",
      icon: <DebugPanelIcon />,
      name: "Developer tools",
      onSelect: () => {
        setOpened(!opened);
      },
    }),
    [opened],
  );

  if (!opened) return null;

  return <DebugPanelWithDnD onClose={() => setOpened(false)} />;
}
